import { FunctionComponent, MouseEvent, useState } from 'react';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { AccountPreview } from '../AccountPreview/AccountPreview';
import { SignOutButton } from './SignOutButton';
import { AccountEmail } from './AccountEmail';
import { AccountPopoverFooter } from './AccountPopoverFooter';
import { IAccountProps } from './Account.interface';

// The width the popover had while its header showed the avatar and the name; kept so the layout does not shrink.
const PopoverContent = styled(Stack)({
  minWidth: 204,
});

export const Account: FunctionComponent<IAccountProps> = (props) => {
  const { slots, slotProps } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {slots?.preview ? (
        <slots.preview handleClick={handleClick} open={open} />
      ) : (
        <AccountPreview
          handleClick={handleClick}
          open={open}
          {...slotProps?.preview}
        />
      )}
      {slots?.popover ? (
        <slots.popover
          open={open}
          onClick={handleClick}
          onClose={handleClose}
          {...slotProps?.popover}
        />
      ) : (
        <Popover
          anchorEl={anchorEl}
          id={'account-menu'}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          {...slotProps?.popover}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: (theme) =>
                  `drop-shadow(0px 2px 8px ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.32)'})`,
                mt: 1,
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            },
            ...slotProps?.popover?.slotProps,
          }}
        >
          {slots?.popoverContent ? (
            <slots.popoverContent {...slotProps?.popoverContent} />
          ) : (
            <PopoverContent {...slotProps?.popoverContent}>
              <AccountEmail />
              {slots?.popoverBody && <slots.popoverBody {...slotProps?.popoverBody} />}
              <AccountPopoverFooter>
                <SignOutButton />
              </AccountPopoverFooter>
            </PopoverContent>
          )}
        </Popover>
      )}
    </>
  );
};
